export const wrapWithDevConnectionState = (fn, getDevState) => ((...args) => {
    const devState = getDevState();
    switch (devState.type) {
        case 'BROKEN': {
            const { status, delay, response } = devState;
            return new Promise((_resolve, reject) => 
            // eslint-disable-next-line prefer-promise-reject-errors
            setTimeout(() => reject(new MockHttpError({ status, response })), delay * 1000));
        }
        case 'DELAYED': {
            const { delay } = devState;
            return Promise.all([fn(...args), new Promise((r) => setTimeout(r, delay * 1000))]).then(([result]) => result);
        }
        default: {
            return fn(...args);
        }
    }
});
const MOCK_REQUEST_ID = 'requestIdMock';
class MockHttpError extends Error {
    constructor(props) {
        super();
        this.response = { status: props.status, requestId: MOCK_REQUEST_ID, ...props.response };
    }
}
export const isMockHttpError = (e) => {
    if ('response' in e) {
        return e.response.requestId === MOCK_REQUEST_ID;
    }
    return false;
};
//# sourceMappingURL=wrap-with-dev-connection-state.js.map